import { QueryObserverOptions, useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

async function queryFn() {
  const {
    data: { id },
  } = await axiosClient.get('/widgets/user');
  return id;
}

export default function useWidgetUser(options?: QueryObserverOptions<any>) {
  return useQuery<string>('widgetUser', () => queryFn(), options);
}
